import $ from "jquery";
import { EEcommerceSystemEnvironment } from "@devowl-wp/api-real-commerce";
import { Subscription } from "./accountV1/subscription.js";
import { __ } from "../utils/i18n.js";
class PaddleSubscription extends Subscription {
    /**
     * @see https://developer.paddle.com/guides/how-tos/checkout/inline-checkout
     */ get Paddle() {
        return this.paddle;
    }
    async loadVendorScripts() {
        // Load Paddle API once
        await $.getScript("https://cdn.paddle.com/paddle/paddle.js");
        this.paddle = window.Paddle;
        if (this.data.productPlan.product.ecommerceSystem.environment === EEcommerceSystemEnvironment.Sandbox) {
            this.paddle.Environment.set("sandbox");
        }
        this.paddle.Setup({
            vendor: +this.data.productPlan.product.ecommerceSystem.vendorId
        });
    }
    getHumanReadablePaymentMethod() {
        const { data: { paymentInformation } } = this;
        const { paymentMethod, cardType, lastFourDigits } = paymentInformation || {};
        let paymentMethodDetails;
        switch(paymentMethod){
            case "paypal":
                paymentMethodDetails = "PayPal";
                break;
            case "PayPal":
                paymentMethodDetails = "PayPal";
                break;
            case "card":
                if (cardType) {
                    switch(cardType){
                        case "master":
                            paymentMethodDetails = `${__("Mastercard")} ${__("credit card")}`;
                            break;
                        case "visa":
                            paymentMethodDetails = `${__("VISA")} ${__("credit card")}`;
                            break;
                        case "american_express":
                            paymentMethodDetails = `${__("American Express")} ${__("credit card")}`;
                            break;
                        case "discover":
                            paymentMethodDetails = `${__("Discover Card")} ${__("credit card")}`;
                            break;
                        case "jcb":
                            paymentMethodDetails = `${__("JCB")} ${__("credit card")}`;
                            break;
                        case "maestro":
                            paymentMethodDetails = `${__("Maestro")} ${__("debit/credit card")}`;
                            break;
                        case "diners_club":
                            paymentMethodDetails = `${__("Diners Club")} ${__("credit card")}`;
                            break;
                        case "unionpay":
                            paymentMethodDetails = `${__("China UnionPay")} ${__("credit card")}`;
                            break;
                        default:
                            paymentMethodDetails = `${__("an unknown credit card")}`;
                            break;
                    }
                    if (lastFourDigits) {
                        paymentMethodDetails += ` (ending with ${lastFourDigits})`;
                    }
                }
                break;
            case undefined:
                paymentMethodDetails = "Not set";
                break;
            default:
                break;
        }
        return paymentMethodDetails || "Unknown";
    }
}
export { PaddleSubscription };
